import { copy } from '../lib/copy';

export function KeyValueList({
  items,
}: {
  items: Array<{ label: string; value: string | number }>;
}) {
  if (items.length === 0) {
    return <p className="text-sm text-ops-muted">{copy.common.notAvailable}</p>;
  }

  return (
    <dl className="space-y-2 text-sm">
      {items.map((item) => (
        <div key={item.label} className="flex justify-between gap-4 border-b border-ops-border py-2 last:border-b-0">
          <dt className="text-ops-muted">{item.label}</dt>
          <dd className="text-right text-ops-text">{item.value}</dd>
        </div>
      ))}
    </dl>
  );
}
